import { AxiosResponse } from 'axios';
import { api } from 'src/common/utils';

import { ParentAccountOption, SurveyConversionResponse } from './types';

type FetchPayloadType = {
  parentId: string;
  accountIds: string[];
  startDate: string;
  endDate: string;
};

export const fetchSurveyConversion = async (
  _: string,
  payload: FetchPayloadType
): Promise<AxiosResponse<SurveyConversionResponse>> => {
  const { parentId, accountIds, startDate, endDate } = payload;
  let queryParams = `?parent_account_id=${parentId}&start_date=${startDate}&end_date=${endDate}`;
  if (accountIds.length > 0) {
    queryParams += `&account_ids=${accountIds.join(',')}`;
  }
  return api.get(`/survey_conversion_admin${queryParams}`);
};

export const fetchParentAccounts = async (search: string): Promise<ParentAccountOption[]> => {
  const queryParams = search ? `?search=${encodeURIComponent(search)}` : '';
  const response = await api.get(`/parent_account_admin${queryParams}`);
  return response.data as ParentAccountOption[];
};
